// tslint:disable
/**
 * CONEXSYS Virtual Schedule API
 *  # Overview CONEXSYS Virtual Schedule API
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@conexsys.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Schedule type
 * @export
 * @enum {string}
 */
export enum ScheduleType {
	Event = 'event',
	Session = 'session',
	Slot = 'slot',
	Meeting = 'meeting'
}

/**
 * @export
 * @const {string[]}
 */
export const valuesScheduleType = [
	'event',
	'session',
	'slot',
	'meeting',
	'declined',
	'declined'
];
